import { GameConstants } from "../../../GameConstants";
import { ChickenWaiting } from "./ChickenWaiting";


    export class ChickenManager {

        private static game: Phaser.Game;
        private static waitingChickens: ChickenWaiting[];
        private static savedChickens: ChickenWaiting[];
        private static f: number;

        public static init(game: Phaser.Game): void {

            this.game = game;

            this.waitingChickens = [];
            this.savedChickens = [];
            this.f = 0;
        }

        public static update(): void {
            
            this.f ++;

            const totalChicken = this.savedChickens.length + this.waitingChickens.length;

            if (this.f > Math.floor(600 / totalChicken) && totalChicken !== 0) {

                this.f = 0;

                const chicken = ChickenManager.getRandomChicken();

                if (Math.random() > .5) {
                    if (chicken && !chicken.pulsing && !chicken.pecking) {
                        chicken.pulse();
                    }
                } else {
                    if (chicken && !chicken.pulsing && !chicken.pecking) {
                        chicken.peck();
                    }
                }
            }
        }

        public static addChicken(chicken: ChickenWaiting, side: string): void {
            
            if (side === GameConstants.LEFT) {
                this.waitingChickens.push(chicken);
            } else {
                this.savedChickens.push(chicken);
            }
        }

        public static getWaitingChicken(): ChickenWaiting {

            let chicken: ChickenWaiting;

            if (this.waitingChickens.length > 0) {
                const i = Math.floor(ChickenManager.waitingChickens.length * Math.random());
                chicken = this.waitingChickens[i];
                this.waitingChickens.splice(i, 1);
            } else {
                chicken = null;
            }

            return chicken;
        }

        public static changeFrameRate(): void {
            
            for (let i = 0; i < this.waitingChickens.length; i++) {
                this.waitingChickens[i].changeFrameRate(8);
            }

            for (let i = 0; i < this.savedChickens.length; i++) {
                this.savedChickens[i].changeFrameRate(8);
            }
        }

        private static getRandomChicken(): ChickenWaiting {

            let chicken: ChickenWaiting;

            if (Math.random() > .5) {
                chicken = Phaser.ArrayUtils.getRandomItem(this.waitingChickens);
            } else {
                chicken = Phaser.ArrayUtils.getRandomItem(this.savedChickens);
            }

            return chicken;
        }
    }
